<template>
  <v-container>
    <div class="custom-center justify-start" style="display:flex;">
        <v-tooltip open-delay="600" max-width="250" color="new_media" bottom style="border-radius:8em!important;">
          <template v-slot:activator="{ on }">
            <v-text-field v-on="on"
              color="new_media"
              style="max-width:300px!important;"
              class="px-3 pt-3"
              placeholder="Saisissez votre thème ici"
              prepend-inner-icon="mdi-magnify"
              v-on:keyup.enter="onlineSearch"
              v-model="query"
              :clearable="true"
              clear-icon="mdi-close-circle"
              rounded
              filled
              dense
              :hide-details="true"
            ></v-text-field>
          </template>
          <span> Pour recherchez une image saisissez un thème ou mot clé. </span>
        </v-tooltip>
      <span class="ml-8 pt-3">Nos sélections :</span>
      <v-tooltip open-delay="600" max-width="250" color="new_media" bottom style="border-radius:8em!important;">
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-select
                :menu-props="{contentClass: 'customSelect'}"
                color="new_media"
                item-color="new_media"
                append-icon="mdi-chevron-down"
                style="max-width:270px!important;"
                class="px-3 pt-3 custom"
                :items="categories"
                placeholder="Choisissez"
                v-model="selectedCategory"
                return-object
                item-text="text"
                item-value="text"
                :hide-details="true"
                disable-lookup
                rounded
                filled
                dense
              ></v-select>
            </div>
          </template>
          <span>Affiche les médias avec le statut sélectionné.</span>
        </v-tooltip>
      <v-spacer></v-spacer>
      <a class="mr-5 pt-3" href="https://pixabay.com/" target="blank"><img :src="currentTheme ? logoPixabay.darkSrc : logoPixabay.lightSrc" id="logoPixabay"></a>
    </div>
    <div id="PixabayContainer" class="scrollNewMedia" style="height: calc(100vh + -250px);position:relative;">
      <div v-if="queryImages.length===0 && isDoneFetching && !noResult" style="height:100%!important;overflow-y:auto!important;overflow-x:hidden!important;">
        <v-row no-gutters>
          <v-col cols="12">
            <div v-for="image in dailyImages" class="col-lg-2 col-md-3 col-sm-4 d-inline-block vert-align" :key="image.id">
              <v-menu open-on-hover  :offset-overflow="true" open-delay="600" transition="slide-y-transition" origin="center"><!-- :absolute="true" attach="#PixabayContainer"  -->
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="blocPhotoPixabay" >
                    <v-img  class="image_with_alpha" :src="image.webformatURL" height="140" cover @click="showCreationModal(image)" :class=" image.imageWidth > image.imageHeight ? photoPixabay : photoPixabayPortrait">
                    </v-img>
                  </div>
                </template>
                  <v-img class="elevation-24" :src="image.webformatURL" height="auto" cover @click="showCreationModal(image)" :class=" image.imageWidth > image.imageHeight ? zoomPhotoPixabay : zoomPhotoPixabayPortrait">
                  </v-img>
              </v-menu>
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-if="queryImages.length>0 && isDoneFetching && !noResult" style="height:100%!important;overflow-y:auto!important;overflow-x:hidden!important;">
        <v-row no-gutters>
          <v-col cols="12">
            <div v-for="image in queryImages" class="col-lg-2 col-md-3 col-sm-4 d-inline-block vert-align" :key="image.id">
              <v-menu open-on-hover  :offset-overflow="true" open-delay="600" transition="slide-y-transition" origin="center"><!-- :absolute="true" attach="#PixabayContainer"  -->
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="blocPhotoPixabay">
                    <v-img class="image_with_alpha" :src="image.webformatURL" height="140" cover @click="showCreationModal(image)" :class=" image.imageWidth > image.imageHeight ? photoPixabay : photoPixabayPortrait">
                    </v-img>
                  </div>
                </template>
                  <v-img class="elevation-24" :src="image.webformatURL" height="auto" cover @click="showCreationModal(image)" :class=" image.imageWidth > image.imageHeight ? zoomPhotoPixabay : zoomPhotoPixabayPortrait">
                  </v-img>
              </v-menu>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <div v-if=" isDoneFetching && noResult">
      <h3> Aucun résultat trouvé, essayez d'autres mots clés. </h3>
    </div>
    <modals-container class="modal-container"/>
  </v-container>
</template>

<script>
import CreationModal from './CreationModal'
import AnimationModal from './AnimationModal'
import axios from 'axios'

export default {
  props: ['modal'],
  data () {
    return {
      dailyImages: [],
      queryImages: [],
      query: '',
      isDoneFetching: false,
      selectedCategory: {id: 0, text: this.$i18n.t('categories.0')},
      categories: [
        {id: 0, text: this.$i18n.t('categories.0')},
       /*  {id: 1, text: this.$i18n.t('categories.1')},
        {id: 2, text: this.$i18n.t('categories.2')}, */
        {id: 3, text: this.$i18n.t('categories.3')},
        {id: 4, text: this.$i18n.t('categories.4')},
       /*  {id: 5, text: 'Catalogue Intermarché'},
        {id: 6, text: 'Catalogue Leclerc'}, */
        {id: 5, text: this.$i18n.t('categories.5')},
        {id: 6, text: this.$i18n.t('categories.6')},
        {id: 7, text: this.$i18n.t('categories.7')},
        {id: 8, text: this.$i18n.t('categories.8')},
        {id: 9, text: this.$i18n.t('categories.9')},
        {id: 10, text: this.$i18n.t('categories.10')},
        {id: 11, text: this.$i18n.t('categories.11')},
        {id: 12, text: this.$i18n.t('categories.12')},
        {id: 13, text: this.$i18n.t('categories.13')},
        /* {id: 14, text: 'Autres'} */
      ],
      photoPixabay: 'photoPixabay',
      photoPixabayPortrait: 'photoPixabay_portrait',
      zoomPhotoPixabay : 'photoPixabay_Zoom',
      zoomPhotoPixabayPortrait: 'photoPixabay_portrait_Zoom',
      clearable: true,
      noResult: false,
      currentTheme: null,
      logoPixabay: {lightSrc: require('../../assets/images/light_logoPixabay.png'), darkSrc: require('../../assets/images/dark_logoPixabay.png')}
    }
  },
  components: {
    CreationModal,
    AnimationModal
  },
  mounted () {
    this.currentTheme = this.$store.state.theme
    axios.get('https://pixabay.com/api/?key=55785-5311f6dc11479d2611e5df625&order=latest&per_page=24&editors_choice=true&safesearch=true')
      .then((response) => {
        this.dailyImages = response.data.hits
        this.isDoneFetching = true
      })
  },
  methods: {
    onlineSearch: function () {
      this.isDoneFetching = false
      if (this.query === '') {
        this.noResult = false
        this.isDoneFetching = true
        this.queryImages = []
        return
      }
      axios.get('https://pixabay.com/api/?key=55785-5311f6dc11479d2611e5df625&q=' + this.query + '&safesearch=true&per_page=24&order=popular&min_height=768&min_width=768&lang=' + this.$store.state.language)
        .then((response) => {
          this.queryImages = response.data.hits
          this.isDoneFetching = true
          this.noResult = this.queryImages.length === 0
        })
    },
    showCreationModal: function (selectedImage) {
      this.$store.dispatch('setPixabayImageURL', selectedImage.imageURL)
      this.$store.dispatch('setPixabayImageID', selectedImage.id)
      if (this.modal === 'image') {
        this.$modal.show(CreationModal, {isPDF: false}, {clickToClose: false, adaptive: true, width: '80%', height: '90%'})
      } else {
        this.$modal.show(AnimationModal, {}, {clickToClose: false, adaptive: true, width: '80%', height: '90%'})
      }
      
    }
  },
  watch: {
    selectedCategory: function () {
      if (this.selectedCategory.id > 2) {
        this.isDoneFetching = false
        var queryTerm =  encodeURI(this.selectedCategory.text)
        axios.get('https://pixabay.com/api/?key=55785-5311f6dc11479d2611e5df625&q=' + queryTerm + '&safesearch=true&per_page=24&order=popular&min_height=768&min_width=768&lang=' + this.$store.state.language)
        .then((response) => {
          this.queryImages = response.data.hits
          this.isDoneFetching = true
          this.noResult = this.queryImages.length === 0
        })
      } else if (this.selectedCategory.id === 0) {
        this.noResult = false
        this.isDoneFetching = true
        this.queryImages = []
      } else {
        if (this.selectedCategory.id === 1) {
          var path = '/home/ftp/players/rayontrad/ALL/Fonds'
        } if (this.selectedCategory.id === 2) {
          var path = '/home/ftp/players/rayontrad/ALL/Drapeaux'
        }
      }
    }
  }
}
</script>

<style scoped>
.vert-align{
  vertical-align: top;
}
</style>
